/* eslint-disable react/prop-types */
import heart from '../../../common/images/revamp/icon/heart.svg';
import historyIcon from '../../../common/images/revamp/icon/history.svg';
import customerCare from '../../../common/images/revamp/icon/customercare.svg';
import { useEffect, useMemo, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { setOrder } from '../../../store/reducers/order';
import { CS_UFOOD } from '../../../utils/constants';
import { useHistory } from 'react-router';
import Modal from '../../Modal';
import { ExclamationCircleIcon } from '@heroicons/react/24/solid';
import LiveChat from '../../LiveChat';
import { ActiveOrderIcon, CustomerCareIcon, FavoriteIcon, HeartIcon, HistoryOrderIcon } from '../../../utils/svg';

const Confirmation = (props) => {
	const { handleConfirm, handleCancel } = props;
	return (
		<>
			<div className={`bg-white p-4 rounded-xl shadow-custom transition-transform duration-1000 ease-in-out translate-y-0 relative`}>
				<div className='flex justify-center'>
					<div className='bg-gray-300 h-1.5 w-10 rounded-full' />
				</div>
				<div className='items-center flex justify-center mt-8'>
					<ExclamationCircleIcon className='h-14 w-auto fill-[var(--rose-violet)]' />
				</div>
				<div className='my-5 text-center'>
					<div className='text-gray-900 text-sm font-semibold'>Anda akan diarahkan ke Layanan Pelanggan</div>
					<div className='text-gray-900 text-xs pt-2'>Apakah Anda yakin ingin melanjutkan?</div>
				</div>
				<div className='flex justify-between mt-2 gap-4'>
					<button className='w-full bg-white text-[var(--rose-violet)] border-[var(--rose-violet)] font-semibold text-sm p-3 items-center border' onClick={handleConfirm} id='merchant_change_cart_cancel'>
						Batal
					</button>
					<button onClick={handleCancel} className='w-full bg-[var(--rose-violet)] text-white font-semibold text-sm p-3 items-center border-0' id='merchant_change_cart_confirm'>
						Ya, Lanjutkan
					</button>
				</div>
			</div>
		</>
	);
};

const Menu = () => {
	const history = useHistory();
	const dispatch = useDispatch();
	const user = useSelector((store) => store?.user);

	const [headerMenu, setHeaderMenu] = useState([
		{
			id: 'homepage_favorite',
			name: 'heart',
			icon: <HeartIcon />,
			to: '/favourites',
			badge: {
				show: false,
				value: 0,
				color: '',
			},
		},
		{
			id: 'homepage_order_history',
			name: 'history',
			icon: <HistoryOrderIcon />,
			to: '/history',
			badge: {
				show: false,
				value: 100,
				color: 'bg-red-500',
			},
		},
		{
			id: 'homepage_call_center',
			name: 'customerCare',
			icon: <CustomerCareIcon className={'w-8 h-8 fill-white'} />,
			to: null,
			badge: {
				show: false,
				value: 0,
				color: '',
			},
		},
	]);

	const [popup, setPopup] = useState({
		show: false,
		confirm: false,
		type: null,
		value: null,
	});

	const filteredHeaderMenu = useMemo(() => {
		return headerMenu.filter((item) => {
			if (!user?.is_b2b && item.id === 'homepage_call_center') {
				return false;
			}

			if (process.env.REACT_APP_NODE_ENV !== 'production' && item.id === 'homepage_call_center') {
				return false;
			}
			return true;
		});
	}, [user?.is_b2b]);

	const handleClick = (menu = {}) => {
		if (menu?.name === 'history') {
			dispatch(setOrder({ tab: 'pesanan' }));
		}
		history.push(menu.to);
	};

	const handlePopup = (type, value) => {
		setPopup((prev) => {
			return {
				...prev,
				show: true,
				type,
				value,
			};
		});
	};

	const handleOpenChat = () => {
		if (window.openFreshChat) {
			window.openFreshChat();
		}
	};

	const handleConfirmPopup = () => {
		setPopup({
			show: false,
			confirm: false,
			type: null,
			value: null,
		});
	};

	const handleCancelPopup = () => {
		setPopup((prev) => {
			return {
				...prev,
				show: false,
				confirm: true,
			};
		});
	};

	const confirmationProps = useMemo(() => {
		return {
			handleConfirm: handleConfirmPopup,
			handleCancel: handleCancelPopup,
		};
	}, []);

	useEffect(() => {
		if (popup?.confirm && !popup?.show && popup?.type === 'call') {
			handleOpenChat();
		}
		if (popup.confirm && !popup?.show) {
			setPopup({
				show: false,
				confirm: false,
				type: null,
				value: null,
			});
		}
	}, [popup]);

	return (
		<>
			<div className='grid grid-flow-col gap-2 flex-shrink-0 '>
				{filteredHeaderMenu?.map((menu) => {
					return (
						<div
							key={menu?.name}
							id={menu?.id}
							onClick={() => {
								if (menu.id === 'homepage_call_center') {
									return handlePopup('call', CS_UFOOD);
								}
								handleClick(menu);
							}}
							className='w-8 h-8 grid place-content-center rounded-full bg-gray-700/70 cursor-pointer relative'>
							{menu?.icon}
							{menu?.badge?.show && (
								<div className={`absolute -top-2 -right-2 p-1 rounded-full flex h-4 w-auto ${menu?.badge?.color}`}>
									<span className='text-xxxs text-white'>{menu?.badge?.value > 99 ? '99+' : menu?.badge?.value}</span>
								</div>
							)}
						</div>
					);
				})}
			</div>
			<Modal isOpen={popup?.show} onClose={handleCancelPopup}>
				<Confirmation {...confirmationProps} />
			</Modal>
			{/* {process.env.REACT_APP_NODE_ENV === 'production' && <LiveChat />} */}
		</>
	);
};

export default Menu;
